/*
 * @Description: 主题稿库左侧
 * @Author: pu.yuchun
 * @LastEditors: zhaoqing
 * @Date: 2019-12-03 16:47:36
 * @LastEditTime: 2020-05-26 09:55:46
 */
'use strict';
angular.module('resourceCenterThemeLeftModule', []).directive('themeLeft', [
    '$state',
    'resourceCenterService',
    '$q',
    '$timeout',
    '$stateParams',
    'trsHttpService',
    '$location',
    function($state, resourceCenterService, $q, $timeout, $stateParams, trsHttpService, $location) {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                // selectedParent: '='
            },
            templateUrl: './resourceCenter/theme/left/left_tpl.html',
            link: function($scope, $elem, $attrs) {
                initStatus();

                /**
                 * [initStatus description] 初始化状态
                 * @return {[type]} [description]
                 */
                function initStatus() {
                    $scope.status = {};
                    $scope.data = {
                        themeType: [
                            {
                                name: '执行主题',
                                id: 'execute',
                                children: []
                            },
                            {
                                name: '历史主题',
                                id: 'history',
                                children: []
                            }
                        ]
                    };
                }

                /**
                 * [getTheme description] 获取执行主题
                 * @param {Object} theme 主题对象
                 * @return  {[type]}  [return description]
                 */
                function getTheme(theme) {
                    // let theme = isHistory ? $scope.data.historyTheme : $scope.data.executeTheme;
                    let deffer = $q.defer();
                    if (theme.children.length === 0) {
                        let params = {
                            methodname: 'queryAllTopics',
                            serviceid: 'mlf_newreport',
                            Status: theme.id === 'history' ? '-1' : '0'
                        };
                        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                            theme.children = data;
                            deffer.resolve();
                        });
                    } else {
                        deffer.resolve();
                    }
                    return deffer.promise;
                }

                /**
                 * 选中三级节点
                 * @param  {Object} parent 父选项
                 * @param  {Object} item 子项
                 * @return {[type]} [description]
                 */
                $scope.toThemePage = function(parent, item) {
                    resourceCenterService.go('front.resourcectrl.theme.resource', {
                        type: parent.id,
                        theme: item.TOPICNAME,
                        change: Math.random()
                    });
                    $scope.status.selected = parent.id + item.TOPICID;
                    parent.open = true;
                };

                $scope.expand = function (v) {
                    const deffer = $q.defer();
                    getTheme(v).then(function() {
                        v.expanded = !v.expanded;
                        deffer.resolve();
                    });
                    return deffer.promise;
                };

                // 根据 url 自动选择主题
                var themeType = $scope.data.themeType[0];
                var themeItem;
                if ($stateParams.type && $stateParams.theme) {
                    $scope.data.themeType.forEach((t) => {
                        if (t.id === $stateParams.type) {
                            themeType = t;
                        }
                    });
                }
                $scope.expand($scope.data.themeType[0]).then(function() {
                    themeType.children.forEach((theme) => {
                        if (theme.TOPICNAME === $stateParams.theme) {
                            themeItem = theme;
                        }
                    });
                    if (!themeItem) {
                        themeItem = themeType.children[0];
                    }
                    $scope.toThemePage(themeType, themeItem || {});
                });
            }
        };
    }
]);
